import { configureStore, combineReducers, } from "@reduxjs/toolkit";
import authReducer from "@application/features/auth/authSlice";
import loadingReducer from "@application/features/Common/loadingSlice";
import eventReducer from "@application/features/Event/EventSlice";
import externalReducer from "@application/features/external/externalSlice";
import companyReducer from "@application/features/company/companySlice";
import notificationReducer from "@application/features/Common/notificationSlice";
import userReducer from "../features/users/userSlice";
import personalInfoReducer from "../features/personalInfo/personalInfoSlice";
import adultReducer from "../features/adult/adultSlice";
import childReducer from "../features/children/childrenSlice";
import dietaryOptionsReducer from "../features/dietaryOptions/dietaryOptionsSlice";
import importantInfoReducer from "../features/importantInformation/importantInfoSlice";
import userDesignationsReducer from "../features/userDesignations/userDesignationsSlice";
import invitationReducer from "../features/invitation/invitationSlice";
import contactUsReducer from "../features/contactUs/contactusSlice";
import roleReducer from "../features/Role/roleSlice";
import accommodationReducer from "../features/accommodation/accommodationSlice";
import transportReducer from "../features/transport/transportSlice";
import globalSearchSlice from "../features/globalSearch/globalSearchSlice";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";
import { pdokApi } from "@application/features/pdok/models/pdok-api";
import pickupLocationSlice from "@application/features/pickupLocation/pickupLocationSlice";
// At the top
let dynamicPersistKey = "root"; // default fallback key
export const setPersistKey = (key) => {
    dynamicPersistKey = `root_${key}`;
};
const persistConfig = {
    key: dynamicPersistKey,
    storage,
    whitelist: ["event"], // Only persist event reducer
};
const combinedReducers = combineReducers({
    [pdokApi.reducerPath]: pdokApi.reducer,
    loading: loadingReducer,
    notification: notificationReducer,
    auth: authReducer,
    event: eventReducer,
    external: externalReducer,
    company: companyReducer,
    user: userReducer,
    person: personalInfoReducer,
    adult: adultReducer,
    children: childReducer,
    accommodation: accommodationReducer,
    transport: transportReducer,
    dietaryOptions: dietaryOptionsReducer,
    importantInfo: importantInfoReducer,
    userDesignations: userDesignationsReducer,
    role: roleReducer,
    invitation: invitationReducer,
    contactUs: contactUsReducer,
    pickupLocation: pickupLocationSlice,
    globalSearch: globalSearchSlice,
});
const persistedReducer = persistReducer(persistConfig, combinedReducers);
const rootReducer = (state, action) => {
    if (action.type === "auth/logout") {
        return combinedReducers(undefined, action);
    }
    return combinedReducers(state, action);
};
export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: {
            ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
        },
    }).concat(pdokApi.middleware),
});
export const persistor = persistStore(store);
